// extracted by mini-css-extract-plugin
module.exports = {"text":"UserDetailHeaderBio_text__38AV-","sending":"UserDetailHeaderBio_sending__XivTA"};